import {Component, Input, OnInit, AfterViewChecked} from '@angular/core';
import {LotteriesService} from '../../lotteries.service';
import * as globals from '../../settings';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {IncomingdrawsService} from '../../_services/incomingdraws.service';
import {SubscriptionsService} from '../../_services/subscriptions.service';

@Component({
    selector: 'app-images-row',
    templateUrl: './images-row.component.html',
    styleUrls: ['./images-row.component.scss']
})
export class ImagesRowComponent implements OnInit {
    lottery: any;
    lotteries: any;
    lottNumbers: any[];
    lotteryWord: any;
    showVerify: any;
    modalSize: any;
    showRestricted: any;
    paymentSucceeded: boolean;
    devMode: boolean;
    prevent: boolean;
    quickPick: number;
    quickPickPrice: number;
    quickPickCurrency: string;
    public isRegistred: any;
    lotteryId: number;
    lotteryName: string;
    urlLotteryName: string;
    quickPickPackageId: number;
    user: any;
    quickPickName: string;
    noOffer: boolean;
    isLoadingButton: boolean;
    showLang: any;
    incomingDrawsSubscription: Subscription;
    brand = globals.brand;
    @Input() containerCssClass: string;

    constructor(public lotteryService: LotteriesService, private router: Router,
                public incomingDraws: IncomingdrawsService, private subscriptionsService: SubscriptionsService) {
    }

    ngOnInit() {
        this.getLang();
        const user = localStorage.getItem('playerDetails');
        this.user = JSON.parse(user);
        this.isLoadingButton = false;

        this.incomingDrawsSubscription = this.subscriptionsService.getIncomingDraws().subscribe(result => {
            this.lotteries = result;
            this.lottery = this.lotteries[0];
            this.lotteryWord = this.lottery.jackpotAsStringRounded[1].replace(/\s/g, '');

            this.lottNumbers = this.lottery.jackpotAsStringRounded[0].replace(',', 'c').replace('.', 'd').split('');
            this.lotteryId = this.lotteries[0].LotteryID;
            this.lotteryName = this.lotteries[0].LotteryName;
            this.urlLotteryName = this.lotteries[0].urlLotteryName;
            this.lotteryService.getLotteries
            (globals.appDomain +
                '/draws/getBundlesOfferById/getBundlesOfferById.html?country=' +
                localStorage.getItem('country') +
                '&lotteryId=' +
                this.lotteries[0].LotteryID)
                .subscribe(
                    res => {
                        if (res.message === 'no offers') {
                            this.noOffer = true;
                        } else {
                            this.quickPick = res[0].Items[0].NumberOfEntries;
                            this.quickPickPrice = res[0].OnlinePrice;
                            this.quickPickCurrency = res[0].Currency;
                            this.quickPickPackageId = res[0].PackageID;
                            this.quickPickName = res[0].Name;
                        }
                    }
                );
        });
    }

    getLang() {
        if (localStorage.getItem('pageLanguage') === 'de'
         || localStorage.getItem('pageLanguage') === 'vi'
         || localStorage.getItem('pageLanguage') === 'id'
         || localStorage.getItem('pageLanguage') === 'en') {
            this.showLang = localStorage.getItem('pageLanguage');
        } else {
            setTimeout(() => {
                this.getLang();
            }, 200);
        }
    }

    buyPackage(id, url, lotteryName, entries, price, packageId, name) {
        this.isLoadingButton = true;
        if (this.noOffer === true) {
            this.router.navigate(['/' + this.showLang, 'lotteries', this.lottery.urlLotteryName]);
            this.isLoadingButton = false;
        } else {
            let memberId = '';
            let sessionId = '';
            if (this.user !== null && this.user !== undefined) {
                sessionId = this.user.sessionId;
                memberId = this.user.memberId;
            } else {
                sessionId = 'false';
                memberId = 'false';
            }

            const sendData = {};
            sendData['lotteryLink'] = url;
            sendData['lotteryId'] = id;
            sendData['numberOfEntries'] = entries;
            sendData['lotteryName'] = lotteryName;
            sendData['lotteryItemPrice'] = price;
            sendData['drawCount'] = 1;
            sendData['billingPeriod'] = 0;
            sendData['isSubscription'] = 0;
            sendData['packageId'] = packageId;
            sendData['name'] = name;
            sendData['sessionId'] = sessionId;
            sendData['memberId'] = memberId;

            this.lotteryService.postData
            (globals.appDomain + '/cart/makeBundle/response.html', this.lotteryService.getFormUrlEncoded(sendData))
                .subscribe(
                    result => {
                        const addToCartItem = result.message;
                        const currentCart = localStorage.getItem('cart');
                        if (currentCart !== null && currentCart !== undefined) {
                            const jsonCart = JSON.parse(currentCart);
                            jsonCart.push(addToCartItem);
                            localStorage.setItem('cart', JSON.stringify(jsonCart));
                        } else {
                            const cartArray = [];
                            cartArray.push(addToCartItem);
                            localStorage.setItem('cart', JSON.stringify(cartArray));
                        }

                        this.router.navigate(['/' + this.showLang, 'cart']).then(nav => {
                            this.isLoadingButton = false;
                        }, err => {
                            this.isLoadingButton = false;
                        });
                    }
                );
        }
    }

}
